var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPointerGreenRoaming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 53,
    viewBox: "0 0 44 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4076_14884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0059 2.5737e-05C24.6361 0.00429447 27.2399 0.527997 29.6671 1.54104C32.0942 2.55413 34.2977 4.03656 36.1505 5.90335C39.896 9.64898 42 14.7293 42.0001 20.0264C42.0001 25.3236 39.8961 30.4047 36.1505 34.1504L22.0264 47.9639L7.92 34.166C6.05104 32.3153 4.56571 30.1137 3.54988 27.6875C2.53407 25.2614 2.0073 22.6585 2.00007 20.0283C1.99288 17.3981 2.50535 14.7921 3.50789 12.3604C4.51037 9.92885 5.98322 7.71926 7.84187 5.85842C9.70069 3.99751 11.9094 2.52192 14.3399 1.51663C16.7704 0.511393 19.3758 -0.00419759 22.0059 2.5737e-05Z",
    fill: "#11B54F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4076_14884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 8C15.93 8 11 12.93 11 19C11 25.07 15.93 30 22 30C22.49 30 22.96 29.96 23.43 29.9C23.41 29.82 23.38 29.74 23.38 29.65V25.41C22.99 26.14 22.54 26.84 22 27.49C20.22 25.29 19.23 22.67 19.04 20H24.6C24.6 20 24.62 20 24.63 20H27.99C27.99 20 28.05 20 28.08 20H30.95C30.92 20.3 30.85 20.59 30.78 20.88C30.89 20.96 31.01 21.03 31.11 21.13C31.67 21.64 32.04 22.28 32.24 23C32.72 21.76 33 20.42 33 19.01C33 12.93 28.07 8 22 8ZM19.68 27.69C16.15 26.75 13.47 23.72 13.06 20H17.04C17.21 22.7 18.09 25.35 19.68 27.69ZM17.04 18H13.06C13.47 14.29 16.15 11.26 19.68 10.31C18.1 12.64 17.22 15.3 17.04 18ZM19.04 18C19.24 15.33 20.22 12.71 22 10.51C23.78 12.71 24.77 15.33 24.96 18H19.03H19.04ZM26.96 18C26.79 15.3 25.91 12.65 24.32 10.31C27.85 11.25 30.53 14.28 30.94 18H26.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8299 25.54C31.0599 25.14 31.1699 24.69 31.1699 24.2C31.1699 23.31 30.8699 22.6 30.2699 22.06C29.6699 21.52 28.9099 21.25 27.9899 21.25H24.6299V29.65H27.0299V27.01H27.6299L28.9599 29.65H31.5299L29.8699 26.52C30.2799 26.27 30.5999 25.95 30.8199 25.55L30.8299 25.54ZM28.5499 24.82C28.3999 24.96 28.1999 25.02 27.9399 25.01H27.0299V23.45H27.9399C28.1999 23.45 28.3999 23.52 28.5499 23.66C28.6999 23.8 28.7699 23.99 28.7699 24.24C28.7699 24.49 28.6999 24.68 28.5499 24.82Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4076_14884",
    x: 0,
    y: 0,
    width: 44.0001,
    height: 52.9639,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4076_14884"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4076_14884",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4076_14884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(11 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPointerGreenRoaming);
export default __webpack_public_path__ + "static/media/map_pointer_green_roaming.d0a0bfe127dd66018733e5eb45f39065.svg";
export { ForwardRef as ReactComponent };